import * as XLSX from "xlsx";
import { formatDot } from "./rekapAbsensiUtils";

const COLUMN_WIDTHS = [
  5, 17, 28, 35, 12, 10, 12, 16, 16, 14, 18, 14, 16, 16, 16, 16, 20, 20, 22, 20,
  14, 12, 12, 16, 16, 16,
];

const HARI_PERMANENT_PER_BULAN = 30;

const isProbationRow = (row) =>
  (row.hariFullProbation || 0) > 0 ||
  (row.totalGajiProbation || 0) > 0 ||
  (row.totalGajiSetengahHariProbation || 0) > 0 ||
  (row.uangShiftOneProbationRp || 0) > 0 ||
  (row.totalLemburProbationRp || 0) > 0 ||
  (row.totalLemburJamProbationRp || 0) > 0 ||
  (row.potonganAlphaProbation || 0) > 0;

export const isEligibleForExport = (row, periodeEnd) => {
  if (!isProbationRow(row)) return true;
  if (!periodeEnd) return true; // tanpa periode, tidak bisa dinilai
  const until = row.probationUntil
    ? `${row.probationUntil}`.slice(0, 10)
    : null;
  if (!until) return true;
  return until <= `${periodeEnd}`.slice(0, 10);
};

const hitungTotalHariKerjaExport = (row) =>
  row.employeeType === "Permanent"
    ? Math.max(HARI_PERMANENT_PER_BULAN - (row.totalIzinDitolak || 0), 0)
    : row.totalHariKerja;

export const toExcelRow = (row) => ({
  ID: row.id ?? row.userId,
  "No Rekening": row.bankAccountNumber,
  Nama: row.name,
  "Total Diterima": row.takeHomePay,
  Bagian: row.bagian,
  "Hari Full": row.hariFull,
  "Setengah Hari": row.hariHalf,
  "Total Hari Kerja": hitungTotalHariKerjaExport(row),
  "Total Jam Kerja": row.totalJamKerja,
  Gaji: Math.round(row.totalGaji),
  "Gaji Setengah Hari": Math.round(row.totalGajiSetengahHari),
  "Uang Shift 1": Math.round(row.uangShiftOneRp),
  "Total Lembur (Hari)": Math.round(row.totalLemburRp),
  "Total Lembur (Jam)": Math.round(row.totalLemburJamRp),
  "Hari Full Probation": row.hariFullProbation,
  "Gaji Probation": Math.round(row.totalGajiProbation),
  "Gaji Setengah Hari Probation": Math.round(
    row.totalGajiSetengahHariProbation
  ),
  "Uang Shift 1 Probation": Math.round(row.uangShiftOneProbationRp),
  "Total Lembur Probation": Math.round(row.totalLemburProbationRp),
  "Total Lembur Jam Probation": Math.round(row.totalLemburJamProbationRp),
  "Uang Transport": row.uangTransport,
  "Uang Makan": row.uangMakan,
  "BPJS TK": row.bpjsTK,
  "BPJS K": row.bpjsK,
  "Potongan Alpha": Math.round(row.potonganAlpha),
  "Potongan Alpha Probation": Math.round(row.potonganAlphaProbation),
});

export const exportPayrollExcel = (rows, fileName, periodeEnd) => {
  console.log(
    rows.map((r) => ({
      id: r.userId,
      probation: isProbationRow(r),
      until: r.probationUntil,
      periodeEnd,
    }))
  );
  const eligibleRows = rows.filter((r) => isEligibleForExport(r, periodeEnd));

  const totalTakeHomeAll = eligibleRows.reduce(
    (sum, r) => sum + r.takeHomePay,
    0
  );
  const totalBpjsTKAll = eligibleRows.reduce(
    (sum, r) => sum + (r.bpjsTK || 0),
    0
  );
  const totalBpjsKAll = eligibleRows.reduce(
    (sum, r) => sum + (r.bpjsK || 0),
    0
  );
  const countBpjsTK = eligibleRows.filter((r) => (r.bpjsTK || 0) > 0).length;
  const countBpjsK = eligibleRows.filter((r) => (r.bpjsK || 0) > 0).length;

  const sortedRows = [...eligibleRows]
    .sort((a, b) => {
      if (a.bagian < b.bagian) return -1;
      if (a.bagian > b.bagian) return 1;
      return 0;
    })
    .map((row, idx) => ({ No: idx + 1, ...toExcelRow(row) }));

  const jumlahRows = [
    {
      No: "",
      ID: "",
      "No Rekening": "Jumlah",
      Nama: "",
      "Total Diterima": formatDot(totalTakeHomeAll),
      Bagian: "",
    },
    {
      No: "",
      ID: "",
      "No Rekening": `BPJS Ketenagakerjaan (${countBpjsTK} Orang)`,
      Nama: "",
      "Total Diterima": formatDot(totalBpjsTKAll),
      Bagian: "",
    },
    {
      No: "",
      ID: "",
      "No Rekening": `BPJS Kesehatan (${countBpjsK} Orang)`,
      Nama: "",
      "Total Diterima": formatDot(totalBpjsKAll),
      Bagian: "",
    },
    {
      No: "",
      ID: "",
      "No Rekening": "Total",
      Nama: "",
      "Total Diterima": formatDot(totalTakeHomeAll),
      Bagian: "",
    },
  ];

  const workSheet = XLSX.utils.json_to_sheet(
    sortedRows.concat([{}], jumlahRows)
  );
  workSheet["!cols"] = COLUMN_WIDTHS.map((wch) => ({ wch }));

  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, workSheet, "Rekap Absensi");
  XLSX.writeFile(workBook, fileName);
};
